class ComponentRegistrationError extends Error {
  constructor(tagName, reason, message, existingConstructor) {
    super(`[${tagName}] ${message}`);
    this.name = "ComponentRegistrationError";
    this.tagName = tagName;
    this.reason = reason;
    this.existingConstructor = existingConstructor;
  }
}
class BatchRegistrationError extends Error {
  constructor(errors, succeeded) {
    const names = errors.map((e) => e.tagName).join(", ");
    super(`Batch registration failed for: ${names}`);
    this.name = "BatchRegistrationError";
    this.errors = errors;
    this.succeeded = succeeded;
  }
}
export {
  BatchRegistrationError,
  ComponentRegistrationError
};
//# sourceMappingURL=errors.js.map
